import React, { useEffect, useState } from "react";
import { i18n } from "../../../translate/i18n";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button
} from "@material-ui/core";
import { Field } from "formik";
import api from "../../../services/api";
import toastError from "../../../errors/toastError";
import { toast } from "react-toastify";

const ModelField = ({ setFieldValue }) => {
  const [modelList, setModelList] = useState([]);

  const fetchModelosDoBanco = async () => {
    try {
      const { data } = await api.get("/prompt-models");
      setModelList(data);
    } catch (error) {
      toastError(error);
    }
  };

  const atualizarModelosDaOpenAI = async () => {
    try {
      const { data } = await api.get("/prompt-models?forcarAtualizacao=true");
      setModelList(data);
      toast.success("Modelos atualizados com sucesso.");
    } catch (error) {
      toastError(error);
    }
  };

  useEffect(() => {
    fetchModelosDoBanco();
  }, []);

  return (
    <Field name="model">
      {({ field }) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FormControl fullWidth margin="dense" variant="outlined">
          <InputLabel id="model-label">{i18n.t("promptModal.fields.model")}</InputLabel>
            <Select
              label={i18n.t("promptModal.fields.model")}
              id="model-select"
              {...field}
              value={field.value || ""}
              onChange={(e) => setFieldValue("model", e.target.value)}
            >
              {Array.isArray(modelList) && modelList.length > 0 ? (
                modelList.map((model) => (
                  <MenuItem key={model.id} value={model.id}>
                    {model.id}
                  </MenuItem>
                ))
              ) : (
                <>
                  <MenuItem value="gpt-3.5-turbo-1106">gpt-3.5-turbo-1106</MenuItem>
                  <MenuItem value="gpt-4o-mini">gpt-4o-mini</MenuItem>
                </>
              )}
            </Select>
          </FormControl>
          <Button
            onClick={atualizarModelosDaOpenAI}
            variant="outlined"
            color="primary"
            size="small"
            style={{ height: 40, marginTop: 8 }}
          >
            Atualizar
          </Button>
        </div>
      )}
    </Field>
  );
};

export default ModelField;

